interface SvgLeftProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgLeft(props: SvgLeftProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M10.5 19.5L11.5575 18.4425L5.8725 12.75H21V11.25H5.8725L11.5575 5.5575L10.5 4.5L3 12L10.5 19.5Z" fill="currentColor" /></svg>;
}